import { VEHICLE_STATUSES, BID_INCREMENT, AUCTION_TYPES } from '../constants';
import moment from 'moment';

export const getHighestBid = (vehicle, auctionType = AUCTION_TYPES.AUTOAXESS) => {
  const defaultBid = { amount: 0, id: 0, bidder: {} };
  if (auctionType !== AUCTION_TYPES.AUTOAXESS) {
    return vehicle.top_alternative_bid_offer ?? defaultBid;
  }

  return vehicle.highest_bid ?? defaultBid;
};

export const getUserHighestBid = (vehicle, userId) => {
  if (userId && userId === vehicle.proxy_bid?.user_id) {
    return { amount: vehicle.proxy_bid.amount, isProxy: true };
  }

  return { amount: getHighestBid(vehicle)?.amount, isProxy: false };
};

export const getVehicleTimer = vehicle => {
  const endStatuses = [VEHICLE_STATUSES.AWARDED, VEHICLE_STATUSES.PULLED];
  if (endStatuses.includes(vehicle.status)) {
    return 0;
  }

  if (vehicle.auction.type !== 'autoaxess') {
    return moment(vehicle.date_end);
  }

  const isShuffled = vehicle.date_end != null;
  return isShuffled ? moment(vehicle.date_end) : moment(vehicle.auction.date_end);
};

export const getMinBitAmount = (vehicle, user) => {
  const startingBid = Number(vehicle.starting_bid || 100);

  if (vehicle.top_alternative_bid_offer) {
    return Math.max(vehicle.top_alternative_bid_offer.amount + BID_INCREMENT, startingBid);
  }

  if (!vehicle.highest_bid) {
    // no bids -> return starting bid
    return startingBid;
  }

  // proxy belongs to curr user -> increase proxy by bid_increment
  if (user?.id && user.id === vehicle.proxy_bid?.user_id) {
    return Math.max(Number(vehicle.proxy_bid.amount) + BID_INCREMENT, startingBid);
  }

  return Math.max(Number(vehicle.highest_bid.amount ?? 0) + BID_INCREMENT, startingBid);
};
